<script setup lang="ts">
import type { HTMLAttributes, ButtonHTMLAttributes } from 'vue'
import { Primitive, type PrimitiveProps } from 'reka-ui'
import { type ButtonVariants, buttonVariants } from '.'

export type ButtonProps = PrimitiveProps & {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  color?: ButtonVariants['color']
  class?: HTMLAttributes['class']
  disabled?: ButtonHTMLAttributes['disabled']
  type?: ButtonHTMLAttributes['type']
  loading?: boolean
}

const props = withDefaults(defineProps<ButtonProps>(), {
  as: 'button',
  type: 'button',
})

const delegatedProps = computed(() => {
  const { class: _, type, disabled, loading, ...delegated } = props
  return props.as !== 'button' || props.asChild
    ? delegated
    : {
        ...delegated,
        type,
        disabled: disabled || loading,
      }
})
</script>

<template>
  <Primitive
    v-bind="delegatedProps"
    :as="as"
    :as-child="asChild"
    :class="cn(buttonVariants({ variant, size, color }), props.class)"
  >
    <Icon
      v-if="loading"
      name="lucide:loader-2"
      :class="
        cn('mr-2 size-5 animate-spin', {
          'size-4': size === 'sm',
        })
      "
    />
    <slot />
  </Primitive>
</template>
